import IframeTabella from "@/iframe/IframeTabella";

export const iFrameRoutes = [
  {
    path: "/iframe/tabella",
    name: "IframeTabella",
    component: IframeTabella,
    meta: { translationKey: "iframe" },
  },
];
